import { showErrorSnackbar } from '../snackbar/provider';

// Error Boundary에서 감지된 에러를 처리하는 함수
export const handleError = (error: any) => {
  // 커스텀 메시지로 이슈 제목 설정
  // Sentry.captureMessage(`script error > ${error?.message || 'error message 없음'}`, {
  //   level: 'error',
  //   fingerprint: ['script-error', new Date().toLocaleString()],
  //   extra: {
  //     originalError: error,
  //     deviceOS: JSON.stringify(localStorageUtil.getDeviceOS()),
  //     userParams: JSON.stringify(localStorageUtil.getUserParams()),
  //     url: window.location.href,
  //     userAgent: navigator.userAgent,
  //     timestamp: new Date().toISOString(),
  //   },
  //   tags: {
  //     errorType: 'general',
  //     component: 'error-boundary',
  //   },
  //   contexts: {
  //     errorInfo: {
  //       customTitle: '일반 스크립트 에러',
  //       errorSource: 'error-boundary',
  //     },
  //   },
  // });

  showErrorSnackbar();
};
